export default "__VITE_ASSET__Cy_TP71a__"